import * as React from "react";
import { Alert, AlertTitle, Button, Stack, Typography, IconButton, Box } from "@mui/material";
import { XIcon, EnvelopeSimpleIcon } from "@phosphor-icons/react/dist/ssr";
import { useAuth } from "@/components/core/auth-provider";

export function EmailVerificationBanner(): React.JSX.Element | null {
	const { user, isEmailVerified, sendEmailVerification } = useAuth();
	const [isSending, setIsSending] = React.useState(false);
	const [isDismissed, setIsDismissed] = React.useState(false);

	if (!user?.email || isEmailVerified || isDismissed) {
		return null;
	}

	const handleResendVerification = async () => {
		setIsSending(true);
		try {
			await sendEmailVerification();
      handleDismiss();
		} catch (error) {
			console.error("Failed to send verification email:", error);
		} finally {
			setIsSending(false);
		}
	};

	const handleDismiss = () => {
		setIsDismissed(true);
	};

	return (
		<Alert 
			severity="warning" 
			sx={{ 
        position: "relative",
				borderRadius: 0,
				borderLeft: 0,
				borderRight: 0,
				borderTop: 0,
			}}
			action={
				<Stack direction="row" spacing={1} alignItems="center" position="absolute" right={4} top={4}>
					<IconButton
						size="small"
						onClick={handleDismiss}
						sx={{ color: "warning.main" }}
					>
						<XIcon />
					</IconButton>
				</Stack>
			}
		>
			<AlertTitle sx={{ mb: 0.25 }}>Email Verification Required</AlertTitle>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
        <Typography variant="body2">
          Please verify your email address <strong>{user.email}</strong>.
          Check your inbox for a verification link.
        </Typography>
        <Button
						variant="outlined"
						size="small"
						onClick={handleResendVerification}
						disabled={isSending}
						startIcon={<EnvelopeSimpleIcon />}
						sx={{ 
							color: "warning.main",
							borderColor: "warning.main",
							"&:hover": {
								borderColor: "warning.dark",
							}
						}}
					>
						{isSending ? "Sending..." : "Resend Email"}
					</Button>
      </Box>
		</Alert>
	);
}
